export default __webpack_public_path__ + "static/genopets-5-b-f8a6295915cb443c9ec2037134ca8b8c.webp";